import { render } from "./TabsQuestions.vue?vue&type=template&id=48835e79&scoped=true"
import script from "./TabsQuestions.vue?vue&type=script&lang=js"
export * from "./TabsQuestions.vue?vue&type=script&lang=js"

import "./TabsQuestions.vue?vue&type=style&index=0&id=48835e79&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48835e79"]])

export default __exports__